var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Typography } from "@mui/material";
export const TText = (_a) => {
    var { text, isUnderline = false } = _a, typographyProps = __rest(_a, ["text", "isUnderline"]);
    return (React.createElement(Typography, Object.assign({ noWrap: true, title: text }, typographyProps, { sx: Object.assign({ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textDecoration: isUnderline ? "underline" : "none" }, typographyProps.sx) }), text));
};
